module.exports = __webpack_public_path__ + "static/img/OXFORD-OAK.93df12d.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/OXFORD-OAK.png
// module id = CjvA
// module chunks = 0